import React, {Component} from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class StreamNavigation extends Component {
    constructor(props) {
		super(props);
		this.state = {}
    }

    renderNavigationItems = () => {
        const showDescriptionLink = this.props.streamEvent;
        const showArtistsLink = this.props.streamEvent && this.props.streamEvent.artists && this.props.streamEvent.artists.length > 0;
        const showPlaybillderLink = this.props.streamEvent && this.props.streamEvent.playbilder_url && this.props.streamEvent.playbilder_url !== "";
        const showNavigation = showDescriptionLink || showArtistsLink || showPlaybillderLink;
        if (showNavigation) {
            return (
                <div className="showtix-navigation__stream">
                    <div className="showtix-badge showtix-background__grey-3">
                        {strings.title}
                    </div>
                    <ul className="showtix-navigation__list">
                        {this.renderDescriptionLink(showDescriptionLink)}
                        {this.renderArtistsLink(showArtistsLink)}
                        {this.renderPlaybillderLink(showPlaybillderLink)}
                    </ul>
                </div>
            )
        }
    };

    renderDescriptionLink = (showDescriptionLink) => {
        if (showDescriptionLink) {
            return (
                <li className="showtix-navigation__item">
                    <button className="showtix-navigation__link"
                            onClick={this.props.showStreamDescriptionModal}
                    >
                        {strings.description}
                    </button>
                </li>
            )
        }
    };

    renderArtistsLink = (showArtistsLink) => {
        if (showArtistsLink) {
            return (
                <li className="showtix-navigation__item">
                    <button className="showtix-navigation__link"
                            onClick={this.props.showStreamArtistsModal}>
                        {strings.artists}
                    </button>
                </li>
            )
        }
    };

    renderPlaybillderLink = (showPlaybillderLink) => {
        if (showPlaybillderLink) {
            return (
                <li className="showtix-navigation__item">
                    <a className="showtix-navigation__link"
                       href={this.props.streamEvent.playbilder_url}
                       target="_blank" rel="noopener"
                    >
                        {strings.playbillder}
                    </a>
                </li>
            )
        }
    };
    
    render() {
        return (
            <React.Fragment>
                {this.renderNavigationItems()}
            </React.Fragment>
        );
    }
}

StreamNavigation.propTypes = {
    showStreamDescriptionModal: PropTypes.func,
    showStreamArtistsModal: PropTypes.func,
    streamEvent: PropTypes.object
}

export default StreamNavigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/StreamNavigation/StreamNavigation.js